module.exports = __webpack_public_path__ + "static/wpe-gradient-ac4bdd14596d393e6177acdaae8c1235.jpg";